module.exports = __webpack_public_path__ + "img/login-indorock.7020c8c5.svg";